import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { supabase } from "../../../lib/supabase/client";
import ReadOnlyGantt, { fmtDate, s } from "../ExternalTimeline";
import ReadOnlyList from "../ExternalTaskList";

function Watermark() {
  return (
    <>
      <style>{`
        @media print { body { display: none !important; } }
        * { -webkit-user-select: none; user-select: none; }
      `}</style>
      <div style={{ position: "fixed", inset: 0, pointerEvents: "none", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden" }}>
        {Array.from({ length: 12 }).map((_, i) => (
          <div key={i} style={{
            position: "absolute", top: `${(i % 4) * 30 - 10}%`, left: `${Math.floor(i / 4) * 40 - 10}%`,
            transform: "rotate(-35deg)", fontSize: 13, fontWeight: 800,
            color: "rgba(139,49,68,0.06)", letterSpacing: "0.15em",
            whiteSpace: "nowrap", fontFamily: "Montserrat, sans-serif",
          }}>CONFIDENTIAL · KHAVE</div>
        ))}
      </div>
    </>
  );
}

export default function ExternalProjectView() {
  const { token } = useParams();
  const [state, setState] = useState("loading");
  const [project, setProject] = useState(null);
  const [milestones, setMilestones] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [view, setView] = useState("gantt");

  useEffect(() => {
    async function load() {
      try {
        const { data, error } = await supabase.rpc("external_project_by_token", { p_token: token });
        if (error || !data) { setState("invalid"); return; }
        setProject(data.project);
        setMilestones(data.milestones || []);
        setTasks(data.tasks || []);
        setState("valid");
      } catch { setState("invalid"); }
    }
    load();
  }, [token]);

  if (state === "loading") return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh", fontFamily: "Montserrat, sans-serif", color: "var(--khv-text-secondary)", fontSize: 13 }}>Loading…</div>
  );

  if (state === "invalid") return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "100vh", fontFamily: "Montserrat, sans-serif", textAlign: "center", padding: 40 }}>
      <div style={{ fontSize: 32, marginBottom: 16 }}>🔒</div>
      <div style={{ fontSize: 16, fontWeight: 800, color: "var(--khv-text-primary)", marginBottom: 8 }}>Invalid or Expired Link</div>
      <div style={{ fontSize: 12, color: "var(--khv-text-secondary)" }}>This project link is no longer valid. Please contact the project owner for a new invite.</div>
    </div>
  );

  return (
    <div style={s.page}>
      <Watermark />
      <div style={s.header}>
        <div style={s.logo}>KHAVE®</div>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <span style={{ color: "rgba(255,255,255,0.5)", fontSize: 11 }}>Project View</span>
          <span style={s.badge}>VIEW ONLY · CONFIDENTIAL</span>
        </div>
      </div>
      <div style={s.content}>
        <div style={s.projectTitle}>{project.name}</div>
        <div style={s.projectMeta}>
          {project.assignee_name && `Assignee: ${project.assignee_name} · `}
          {project.start_date && `Start: ${fmtDate(project.start_date)} · `}
          {project.end_date && `End: ${fmtDate(project.end_date)}`}
        </div>
        <div style={s.tabBar}>
          <button style={s.tab(view === "gantt")} onClick={() => setView("gantt")}>📅 Gantt</button>
          <button style={s.tab(view === "list")} onClick={() => setView("list")}>☰ List</button>
        </div>
        {view === "gantt" && <ReadOnlyGantt project={project} milestones={milestones} />}
        {view === "list"  && <ReadOnlyList  project={project} tasks={tasks} />}
        <div style={{ marginTop: 32, textAlign: "center", fontSize: 10, color: "var(--khv-text-muted)" }}>
          KHAVE® Command Portal · This document is confidential and intended for the named recipient only.
        </div>
      </div>
    </div>
  );
}
